// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__btQg4","disabled":"FileBtn_disabled__3MXiE","warn":"FileBtn_warn__10sIJ","fade":"FileBtn_fade__2cMxo"};